/* PDFCommunity - v44 extras.
   1. Works offline + installable as an app (registers /sw.js, shows an
      offline notice, an "Install app" button and a one-time "ready for
      offline use" message).
   2. Upload meter: while a tool works, it shows how much was processed on
      this device and how many bytes were sent to any server. The bytes are
      measured, not assumed: every fetch, XMLHttpRequest and sendBeacon body
      the page sends is counted.
   (v147) Loaded with defer as the first script in <head> (only pc-theme.js,
   the theme, blocks the page): deferred scripts run in document order, so
   the meter is in place before any other script of the page (ga-loader.js,
   consent.js, app.js, the Cloudflare module at the end of <body>) can send
   a request. It never touches file processing. */
(function () {
  'use strict';
  var LANG = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2);

  /* (v136) theme: automatic / light / dark. (v147) Applied by pc-theme.js,
     which blocks the page and runs before style.css; the theme button below
     uses its functions. */
  var THEME_KEY = PC_THEME_KEY, THEMES = PC_THEMES, storedTheme = pcStoredTheme, applyTheme = pcApplyTheme;
  var THEME_TOAST_MS = 2500;
  var T = {
    en: { close: 'Close',
      themeAutoShort: 'Automatic', theme: 'Theme: {m}', themeAuto: 'automatic (like your device)', themeLight: 'light', themeDark: 'dark', themeNoSave: 'This browser cannot remember your theme choice, so it only applies to this page.', fbLink: 'Something not right once you open the file? Tell us', fbTab: 'Feedback', contact: '/contact.html',
      offline: "You're offline. The tools keep working; only a watermark with special characters or a non-Latin script, and some PDFs with Asian text, need internet.", ready: 'Most PDFCommunity tools now also work without internet.',
      iosTip: "On iPhone or iPad: tap Share (the square with the arrow; sometimes under •••), then ‘Add to Home Screen’.",
      install: 'Install app', local: '{s} processed on this device', zero: '0 bytes of your files uploaded',
      stats: '{n} bytes of site statistics sent to Cloudflare/Google', other: '{n} bytes sent to a server',
      how: 'Measured by your browser while the tool was working: every request this page sent is counted.' },
    nl: { close: 'Sluiten',
      themeAutoShort: 'Automatisch', theme: 'Thema: {m}', themeAuto: 'automatisch (zoals je toestel)', themeLight: 'licht', themeDark: 'donker', themeNoSave: 'Deze browser kan je themakeuze niet onthouden, dus ze geldt alleen voor deze pagina.', fbLink: 'Klopt er iets niet als je het bestand opent? Laat het ons weten', fbTab: 'Feedback', contact: '/nl/contact.html',
      offline: 'Je bent offline. De tools blijven werken; alleen een watermerk met speciale tekens of een niet-Latijns schrift, en sommige PDF\'s met Aziatische tekst, hebben internet nodig.', ready: 'De meeste tools van PDFCommunity werken nu ook zonder internet.',
      iosTip: "Op iPhone of iPad: tik op Delen (het vierkantje met de pijl, soms onder •••) en kies ‘Zet op beginscherm’.",
      install: 'App installeren', local: '{s} verwerkt op dit toestel', zero: '0 bytes van je bestanden geüpload',
      stats: '{n} bytes sitestatistiek naar Cloudflare/Google verstuurd', other: '{n} bytes naar een server verstuurd',
      how: 'Gemeten door je browser terwijl de tool bezig was: elk verzoek dat deze pagina verstuurde, telt mee.' },
    fr: { close: 'Fermer',
      themeAutoShort: 'Automatique', theme: 'Thème : {m}', themeAuto: 'automatique (comme votre appareil)', themeLight: 'clair', themeDark: 'sombre', themeNoSave: 'Ce navigateur ne peut pas retenir votre choix de thème : il ne vaut que pour cette page.', fbLink: 'Un souci en ouvrant le fichier ? Dites-le-nous', fbTab: 'Votre avis', contact: '/fr/contact.html',
      offline: 'Vous êtes hors ligne. Les outils continuent de fonctionner ; seuls un filigrane avec des caractères spéciaux ou une écriture non latine, et certains PDF avec du texte asiatique, nécessitent internet.', ready: 'La plupart des outils PDFCommunity fonctionnent désormais aussi sans internet.',
      iosTip: "Sur iPhone ou iPad : touchez Partager (le carré avec la flèche, parfois sous •••), puis « Sur l’écran d’accueil ».",
      install: "Installer l'app", local: '{s} traités sur cet appareil', zero: '0 octet de vos fichiers envoyé',
      stats: '{n} octets de statistiques du site envoyés à Cloudflare/Google', other: '{n} octets envoyés à un serveur',
      how: "Mesuré par votre navigateur pendant le traitement : chaque requête envoyée par cette page est comptée." },
    de: { close: 'Schließen',
      themeAutoShort: 'Automatisch', theme: 'Farbschema: {m}', themeAuto: 'automatisch (wie Ihr Gerät)', themeLight: 'hell', themeDark: 'dunkel', themeNoSave: 'Dieser Browser kann Ihre Wahl nicht speichern, sie gilt deshalb nur für diese Seite.', fbLink: 'Stimmt beim Öffnen der Datei etwas nicht? Sagen Sie es uns', fbTab: 'Feedback', contact: '/de/kontakt.html',
      offline: 'Sie sind offline. Die Tools funktionieren weiter; nur ein Wasserzeichen mit Sonderzeichen oder nicht-lateinischer Schrift und manche PDFs mit asiatischem Text brauchen Internet.', ready: 'Die meisten PDFCommunity-Tools funktionieren jetzt auch ohne Internet.',
      iosTip: "Auf iPhone oder iPad: Tippen Sie auf Teilen (das Quadrat mit dem Pfeil, manchmal unter •••) und dann auf „Zum Home-Bildschirm“.",
      install: 'App installieren', local: '{s} auf diesem Gerät verarbeitet', zero: '0 Byte Ihrer Dateien hochgeladen',
      stats: '{n} Byte Website-Statistik an Cloudflare/Google gesendet', other: '{n} Byte an einen Server gesendet',
      how: 'Von Ihrem Browser gemessen, während das Tool arbeitete: Jede Anfrage dieser Seite wird mitgezählt.' },
    es: { close: 'Cerrar',
      themeAutoShort: 'Automático', theme: 'Tema: {m}', themeAuto: 'automático (como tu dispositivo)', themeLight: 'claro', themeDark: 'oscuro', themeNoSave: 'Este navegador no puede recordar tu elección de tema, así que solo se aplica a esta página.', fbLink: '¿Algo no está bien al abrir el archivo? Cuéntanoslo', fbTab: 'Comentarios', contact: '/es/contacto.html',
      offline: 'Estás sin conexión. Las herramientas siguen funcionando; solo una marca de agua con caracteres especiales o una escritura no latina, y algunos PDF con texto asiático, necesitan internet.', ready: 'La mayoría de las herramientas de PDFCommunity ahora también funcionan sin internet.',
      iosTip: "En iPhone o iPad: toca Compartir (el cuadrado con la flecha, a veces bajo •••) y luego «Añadir a pantalla de inicio».",
      install: 'Instalar app', local: '{s} procesados en este dispositivo', zero: '0 bytes de tus archivos subidos',
      stats: '{n} bytes de estadísticas del sitio enviados a Cloudflare/Google', other: '{n} bytes enviados a un servidor',
      how: 'Medido por tu navegador mientras la herramienta trabajaba: se cuenta cada solicitud que envió esta página.' },
    pt: { close: 'Fechar',
      themeAutoShort: 'Automático', theme: 'Tema: {m}', themeAuto: 'automático (como o seu dispositivo)', themeLight: 'claro', themeDark: 'escuro', themeNoSave: 'Este navegador não consegue lembrar sua escolha de tema, então ela vale só para esta página.', fbLink: 'Algo errado ao abrir o arquivo? Conte para nós', fbTab: 'Feedback', contact: '/pt/contato.html',
      offline: 'Você está offline. As ferramentas continuam funcionando; só uma marca d’água com caracteres especiais ou escrita não latina, e alguns PDFs com texto asiático, precisam de internet.', ready: 'A maioria das ferramentas do PDFCommunity agora também funciona sem internet.',
      iosTip: "No iPhone ou iPad: toque em Compartilhar (o quadrado com a seta, às vezes em •••) e depois em “Adicionar à Tela de Início”.",
      install: 'Instalar app', local: '{s} processados neste dispositivo', zero: '0 bytes dos seus arquivos enviados',
      stats: '{n} bytes de estatísticas do site enviados ao Cloudflare/Google', other: '{n} bytes enviados a um servidor',
      how: 'Medido pelo seu navegador enquanto a ferramenta trabalhava: cada solicitação enviada por esta página é contada.' }, it: { close: 'Chiudi',
      themeAutoShort: 'Automatico', theme: 'Tema: {m}', themeAuto: 'automatico (come il tuo dispositivo)', themeLight: 'chiaro', themeDark: 'scuro', themeNoSave: 'Questo browser non può ricordare la scelta del tema, quindi vale solo per questa pagina.', fbLink: "Qualcosa non va quando apri il file? Diccelo", fbTab: "Feedback", contact: "/it/contatti.html",
      offline: "Sei offline. Gli strumenti continuano a funzionare; solo una filigrana con caratteri speciali o un alfabeto non latino, e alcuni PDF con testo asiatico, richiedono internet.", ready: "La maggior parte degli strumenti di PDFCommunity ora funziona anche senza internet.",
      iosTip: "Su iPhone o iPad: tocca Condividi (il quadrato con la freccia; a volte sotto •••), poi ‘Aggiungi alla schermata Home’.",
      install: "Installa l'app", local: "{s} elaborati su questo dispositivo", zero: "0 byte dei tuoi file caricati",
      stats: "{n} byte di statistiche del sito inviati a Cloudflare/Google", other: "{n} byte inviati a un server",
      how: "Misurato dal tuo browser mentre lo strumento lavorava: viene conteggiata ogni richiesta inviata da questa pagina." }, pl: { close: "Zamknij",
      themeAutoShort: "Automatyczny", theme: "Motyw: {m}", themeAuto: "automatyczny (jak na Twoim urządzeniu)", themeLight: "jasny", themeDark: "ciemny", themeNoSave: "Ta przeglądarka nie może zapamiętać wyboru motywu, więc obowiązuje on tylko na tej stronie.", fbLink: "Coś jest nie tak po otwarciu pliku? Daj nam znać", fbTab: "Uwagi", contact: "/pl/kontakt.html",
      offline: "Jesteś offline. Narzędzia nadal działają; internetu wymagają tylko znak wodny ze znakami specjalnymi lub w alfabecie innym niż łaciński oraz niektóre PDF z tekstem azjatyckim.", ready: "Większość narzędzi PDFCommunity działa teraz także bez internetu.",
      iosTip: "Na iPhonie lub iPadzie: dotknij Udostępnij (kwadrat ze strzałką; czasem pod •••), a potem „Do ekranu początkowego”.",
      install: "Zainstaluj aplikację", local: "Przetworzono na tym urządzeniu: {s}", zero: "Przesłano 0 bajtów Twoich plików",
      stats: "Statystyki serwisu wysłane do Cloudflare/Google (w bajtach): {n}", other: "Wysłano na serwer (w bajtach): {n}",
      how: "Mierzone przez Twoją przeglądarkę podczas pracy narzędzia: liczone jest każde żądanie wysłane przez tę stronę." }
  };
  var S = T[LANG] || T.en;
  var LOCALE = { en: 'en-US', nl: 'nl-BE', fr: 'fr-BE', de: 'de-DE', es: 'es-ES', pt: 'pt-BR', it: 'it-IT', pl: "pl-PL" }[LANG] || 'en-US';

  /* ---------- upload meter: count every request body ---------- */
  var sent = [];                       // { bytes, host }
  // (v49) A body the meter cannot measure (a stream, an unknown type, an
  // error while measuring) counts as at least 1 byte: the meter may only
  // ever show "0 bytes uploaded" when that is proven, never by default.
  function sizeOf(body) {
    if (body == null) return 0;
    try {
      if (typeof body === 'string') return new Blob([body]).size;
      if (body instanceof Blob) return body.size;
      if (body instanceof ArrayBuffer) return body.byteLength;
      if (ArrayBuffer.isView(body)) return body.byteLength;
      if (body instanceof URLSearchParams) return new Blob([body.toString()]).size;
      if (body instanceof FormData) {
        var n = 0; body.forEach(function (v, k) { n += new Blob([k]).size + (v instanceof Blob ? v.size : new Blob([String(v)]).size); }); return n;
      }
    } catch (e) { return 1; }
    return 1;
  }
  function hostOf(u) { try { return new URL(u, location.href).hostname; } catch (e) { return ''; } }
  var OWN_RELEASE_QUERY = /^\?v=\d+$/;
  // (v55) data can also leave in the address itself (a GET with a query)
  function queryBytes(u) {
    try {
      var x = new URL(u, location.href);
      if (x.protocol !== 'https:' && x.protocol !== 'http:') return 0; // data:/blob: never leave the device
      return x.search && !OWN_RELEASE_QUERY.test(x.search) ? new Blob([x.search]).size : 0;
    } catch (e) { return 1; }
  }
  var onSent = []; // redraw hooks of the meters (see setupPanel)
  function push(bytes, host) { sent.push({ bytes: bytes, host: host, at: Date.now() }); onSent.forEach(function (f) { f(); }); }
  function note(url, body) { var b = sizeOf(body) + queryBytes(url); if (b > 0) push(b, hostOf(url)); }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (input && typeof input === 'object' && !(init && init.body != null) && input.method && input.method !== 'GET' && input.method !== 'HEAD') {
          var len = input.headers ? +input.headers.get('content-length') : 0;
          push((len > 0 ? len : 1) + queryBytes(url), hostOf(url));
        } else note(url, init ? init.body : null);
      } catch (e) { push(1, ''); }
      return _fetch.apply(this, arguments);
    };
  }
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__pcUrl = u; return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) { try { note(this.__pcUrl || '', body); } catch (e) { push(1, ''); } return _send.apply(this, arguments); };
  }
  if (navigator.sendBeacon) {
    var _beacon = navigator.sendBeacon.bind(navigator);
    navigator.sendBeacon = function (url, data) { try { push(Math.max(sizeOf(data), 1) + queryBytes(url), hostOf(url)); } catch (e) { push(1, ''); } return _beacon(url, data); };
  }
  /* (v55) An image, script or stylesheet request can carry data in its
     address too; the hooks above don't see those. They are counted through
     the browser's own resource timing (fetch/XHR/beacon are already counted
     above, so they are skipped here). */
  var HOOKED = /^(fetch|xmlhttprequest|beacon)$/;
  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (HOOKED.test(e.initiatorType)) return;
          var u; try { u = new URL(e.name); } catch (err) { return; }
          if (u.protocol !== 'https:' && u.protocol !== 'http:') return;
          var q = queryBytes(e.name);
          if (q > 0) push(q, u.hostname);
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* no resource timing in this browser: the request hooks above still count */ }
  }
  var LATE_REPORT_MS = 3000;
  var TOAST_MS = 5000;     // how long a passing message stays
  var IOS_TIP_MS = 12000;  // the iPhone install steps take longer to read
  var OFFLINE_MS = 8000;   // the offline notice is long, give it time to be read
  var IDLE_WARM_TIMEOUT_MS = 3000; // (v139) latest moment the number formatters are prepared (see init)
  var STATS_HOSTS = /(^|\.)(google-analytics\.com|analytics\.google\.com|googletagmanager\.com|cloudflareinsights\.com)$/;

  /* ---------- helpers ---------- */
  function fmtBytes(b) {
    var nf = function (v, d) { return numFormat(d).format(v); };
    // (v57) French writes file sizes in octets (Ko, Mo, Go)
    var u = LANG === 'fr' ? ['o', 'Ko', 'Mo', 'Go'] : ['B', 'KB', 'MB', 'GB'];
    if (b < 1024) return nf(b, 0) + ' ' + u[0];
    if (b < 1024 * 1024) return nf(b / 1024, 0) + ' ' + u[1];
    if (b < 1024 * 1024 * 1024) return nf(b / 1048576, 1) + ' ' + u[2];
    return nf(b / 1073741824, 2) + ' ' + u[3];
  }
  function fmtInt(n) { return numFormat(null).format(n); }
  // (v139) one formatter per kind: building an Intl.NumberFormat costs a slow phone tens of ms, and the
  // upload meter formats on every progress step, also in the frame that answers a tool's start button (INP)
  var NUM_FORMATS = {};
  function numFormat(digits) {
    var key = String(digits);
    if (!NUM_FORMATS[key]) NUM_FORMATS[key] = digits === null ? new Intl.NumberFormat(LOCALE)
      : new Intl.NumberFormat(LOCALE, { maximumFractionDigits: digits, minimumFractionDigits: digits });
    return NUM_FORMATS[key];
  }
  var SHIELD = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2 4 5v6c0 5 3.4 8.7 8 11 4.6-2.3 8-6 8-11V5l-8-3z" stroke="currentColor" stroke-width="2"/><path d="M8.5 12l2.5 2.5 4.5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var DEVICE = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="4" width="18" height="12" rx="2" stroke="currentColor" stroke-width="2"/><path d="M8 20h8M12 16v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  /* (v49) one shared toast node (pc-interact.js uses it via PDFC_TOAST), created
     EMPTY when the page loads: a live region that appears together with its
     first message is often not read out. The text is set a frame after
     clearing, so a repeated message is read again. */
  /* (v134) the live region is the message span, not the whole toast: the
     close button inside it is then not read out with every message */
  function toastNode() {
    var el = document.querySelector('.pc-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'pc-toast';
      el.innerHTML = '<span class="pc-toast__msg" role="status" aria-live="polite"></span>' +
        '<button type="button" class="pc-toast__x"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button>';
      el.lastChild.setAttribute('aria-label', S.close);
      el.lastChild.addEventListener('click', hideToast);
      document.body.appendChild(el);
    }
    return el;
  }
  function toastText() { var m = document.querySelector('.pc-toast__msg'); return m ? m.textContent : ''; }
  function toast(msg, sticky, ms) {
    var el = toastNode(), m = el.firstChild;
    m.textContent = '';
    requestAnimationFrame(function () { m.textContent = msg; el.classList.add('show'); });
    clearTimeout(el.__t); // one timer slot: an older message never hides a newer one
    if (!sticky) el.__t = setTimeout(function () { el.classList.remove('show'); }, ms || TOAST_MS);
  }
  window.PDFC_TOAST = toast; // (v85) pc-interact.js shows its messages through this one helper
  function hideToast() { var el = document.querySelector('.pc-toast'); if (el) { clearTimeout(el.__t); el.classList.remove('show'); } }

  /* ---------- the meter in each tool panel ---------- */
  function panelBytes(panel) {
    var names = [].map.call(panel.querySelectorAll('.filelist .fname'), function (n) { return n.textContent; });
    var hub = window.PDFC_FILES && window.PDFC_FILES.all ? window.PDFC_FILES.all() : [];
    var total = 0, used = {};
    names.forEach(function (name) {
      for (var i = 0; i < hub.length; i++) if (!used[i] && hub[i].name === name) { used[i] = 1; total += hub[i].size || 0; return; }
    });
    return total;
  }
  function setupPanel(panel) {
    var status = panel.querySelector('.status'), result = panel.querySelector('.result-box');
    if (!status || panel.__pcMeter) return;
    var box = document.createElement('div');
    box.className = 'pc-meter';
    box.title = S.how;
    box.hidden = true;
    box.innerHTML = '<span class="pc-pill pc-pill--local">' + DEVICE + '<span class="pc-local"></span></span>' +
      '<span class="pc-pill pc-pill--zero">' + SHIELD + '<span class="pc-zero"></span></span>' +
      '<span class="pc-note"></span>';
    (result && result.parentNode === status.parentNode ? result : status).insertAdjacentElement('afterend', box);
    var localEl = box.querySelector('.pc-local'), zeroEl = box.querySelector('.pc-zero'), noteEl = box.querySelector('.pc-note');
    var fill = status.querySelector('.progress-fill');
    var run = null, finished = null;
    panel.__pcMeter = true;

    function render(final) {
      var r0 = run || finished;
      if (!r0) return;
      var pct = final ? 1 : Math.max(0, Math.min(1, fill ? parseFloat(fill.style.width) / 100 || 0 : 0));
      localEl.textContent = S.local.replace('{s}', fmtBytes(Math.round(r0.total * pct)));
      var mine = sent.slice(r0.mark).filter(function (r) { return !r0.until || r.at <= r0.until; }), stats = 0, other = 0;
      mine.forEach(function (r) { if (STATS_HOSTS.test(r.host)) stats += r.bytes; else other += r.bytes; });
      zeroEl.textContent = other > 0 ? S.other.replace('{n}', fmtInt(other)) : S.zero;
      box.classList.toggle('pc-meter--warn', other > 0);
      noteEl.textContent = stats > 0 && other === 0 ? S.stats.replace('{n}', fmtInt(stats)) : '';
      noteEl.hidden = !noteEl.textContent;
    }
    new MutationObserver(function () {
      var working = status.classList.contains('working') && status.classList.contains('show');
      if (working && !run) {
        finished = null;
        run = { total: panelBytes(panel), mark: sent.length };
        box.hidden = false; box.classList.remove('pc-meter--done'); render(false);
      } else if (!working && run) {
        var ok = result && result.classList.contains('show');
        // (v55) a request of the run can still be reported a moment after
        // it ended: the finished meter is redrawn for a short while
        finished = ok ? { total: run.total, mark: run.mark, until: Date.now() + LATE_REPORT_MS } : null;
        run = null;
        if (ok) { render(true); box.classList.add('pc-meter--done'); }
        else { box.hidden = true; }
      }
    }).observe(status, { attributes: true, attributeFilter: ['class'] });
    onSent.push(function () {
      if (run) render(false);
      else if (finished && !box.hidden && Date.now() <= finished.until) render(true);
    });
    if (fill) new MutationObserver(function () { render(false); }).observe(fill, { attributes: true, attributeFilter: ['style'] });
    if (result) new MutationObserver(function () {
      if (!result.classList.contains('show') && !run) box.hidden = true;
    }).observe(result, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- offline + install ---------- */
  function setupOffline() {
    /* (v79) the offline notice passes like any other message (it used to
       stay until the connection came back) and is shown once per offline
       stretch, not again on every page opened while offline */
    var OFFLINE_KEY = 'pdfc-offline-shown';
    function upd() {
      if (navigator.onLine) {
        try { sessionStorage.removeItem(OFFLINE_KEY); } catch (e) { /* storage blocked: the notice may simply show again next time */ }
        if (toastText() === S.offline) hideToast();
        return;
      }
      try { if (sessionStorage.getItem(OFFLINE_KEY)) return; sessionStorage.setItem(OFFLINE_KEY, '1'); } catch (e) { /* storage blocked: show it anyway */ }
      toast(S.offline, false, OFFLINE_MS);
    }
    window.addEventListener('offline', upd);
    window.addEventListener('online', upd);
    if (!navigator.onLine) upd();

    var deferred = null, btn = null;
    function installButton(onClick) {
      var host = document.querySelector('header .wrap');
      if (!host) return null;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pc-install';
      b.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 4v11m0 0-4-4m4 4 4-4M5 20h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
      b.lastChild.textContent = S.install;
      b.title = S.install;
      b.addEventListener('click', onClick);
      host.appendChild(b);
      return b;
    }
    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault(); deferred = e;
      if (btn) { btn.hidden = false; return; }
      btn = installButton(function () {
        if (!deferred) return;
        deferred.prompt();
        deferred.userChoice.then(function () { deferred = null; btn.hidden = true; }, function () { /* install prompt dismissed: the button simply stays */ });
      });
    });
    /* (v66) iPhone and iPad never offer an install prompt: there the button
       explains the two taps in the share menu instead. Not shown when the
       site already runs as an installed app. */
    var ios = /iPhone|iPad|iPod/.test(navigator.userAgent || '') || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    // in-app browsers (Facebook, Instagram, Google app) have no 'Add to Home Screen'
    var inApp = /FBAN|FBAV|Instagram|GSA\//.test(navigator.userAgent || '');
    var standalone = navigator.standalone === true || (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches);
    if (ios && !inApp && !standalone) btn = installButton(function () { toast(S.iosTip, false, IOS_TIP_MS); });
    window.addEventListener('appinstalled', function () { if (btn) btn.hidden = true; });

    if (!('serviceWorker' in navigator) || location.protocol === 'file:') return;
    // (v52) only once the page itself has loaded and the browser is idle:
    // the offline copy never competes with the first visit for bandwidth
    var later = function (cb) { if ('requestIdleCallback' in window) window.requestIdleCallback(cb, { timeout: SW_IDLE_TIMEOUT_MS }); else window.setTimeout(cb, SW_IDLE_TIMEOUT_MS); };
    // (v52) no offline copy at all when the visitor asked to save data
    if (navigator.connection && navigator.connection.saveData) return;
    if (document.readyState === 'complete') later(registerSW);
    else window.addEventListener('load', function () { later(registerSW); });
    navigator.serviceWorker.addEventListener('message', function (e) {
      // (v98) a page without tools warms only the site files: that is not "the tools work offline"
      if (!e.data || e.data.type !== 'warmed' || e.data.complete !== true || !e.data.libs) return;
      var key = 'pdfc-offline-ready';
      try { if (localStorage.getItem(key)) return; } catch (err) { return; }
      // (v91) one overlay at a time: the message waits for the cookie banner
      whenNoBanner(function () {
        /* (v121) never over a tool that is in use (files chosen, working or a
           result): the worker reports "warmed" on every page load, so the
           message simply comes on a later, quiet page */
        if (document.querySelector(TOOL_BUSY)) return;
        // a second "warmed" message (a new worker taking over) may be waiting too
        try { if (localStorage.getItem(key)) return; localStorage.setItem(key, '1'); } catch (err) { return; }
        if (navigator.onLine) toast(S.ready);
      });
    });
  }
  function whenNoBanner(cb) {
    if (!document.querySelector('.consent-banner')) return cb();
    var mo = new MutationObserver(function () {
      if (document.querySelector('.consent-banner')) return;
      mo.disconnect(); cb();
    });
    mo.observe(document.body, { childList: true });
  }
  var SW_IDLE_TIMEOUT_MS = 4000;
  var TOOL_BUSY = '.filelist .fname, .status.show, .result-box.show';
  function registerSW() {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).then(function (reg) {
      // pages of this language (footer links) + this page, cached in the background
      var urls = [location.pathname];
      document.querySelectorAll('footer a[href]').forEach(function (a) {
        var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
        if (u.origin === location.origin && !u.hash && (/\.html$/.test(u.pathname) || /\/$/.test(u.pathname))) urls.push(u.pathname);
      });
      /* (v85) the PDF libraries (±3.9 MB) are only fetched for the offline
         copy on pages that run the tools (they load app.js); the other
         pages cache just themselves and the site files. "Works offline"
         is announced only once the libraries are in as well. */
      /* (v94) the Word/PowerPoint conversion (±2.3 MB) only on a page
         with one of those tools */
      var tools = !!document.querySelector('script[src^="/app.js"]');
      // the tool shown on this page (every tool page carries all panels)
      var office = !!document.querySelector('#panel-word.active, #panel-ppt.active, #panel-excel.active');
      var libs = !tools ? false : office ? 'office' : 'pdf';
      var warmed = null; // each worker is asked once (the libraries are not fetched twice)
      function warm(sw) { if (!sw || sw === warmed) return; warmed = sw; sw.postMessage({ type: 'warm', urls: urls, libs: libs }); }
      if (reg.active) warm(reg.active);
      // a first install, or a new release taking over this page: the new
      // worker has its own, empty cache, so it is warmed as well
      navigator.serviceWorker.addEventListener('controllerchange', function () { warm(navigator.serviceWorker.controller); });
    }).catch(function () { /* no service worker (blocked, private mode): the site works online as usual */ });
  }

  /* (v55) Files handed from one page to the next wait in the browser's own
     storage (IndexedDB) for a moment. The page that receives them deletes
     them; this sweep, on every page of the site, deletes a copy that was
     never picked up (a tab closed right away, a page that failed to load)
     once it is older than the hand-over window. It only opens a database
     that already exists, so it never creates storage for a visitor. */
  var HANDOFF_STORES = [
    { db: 'pdfcommunity', store: 'handoff', ts: 'ts', maxAge: 2 * 60 * 1000 },
    { db: 'pdfc-handoff', store: 'files', ts: 'at', maxAge: 60 * 1000 }
  ];
  /* (v90) A page without the tools can never take a copy over: there it is
     deleted once it is HANDOFF_IDLE_MS old (long enough for a tool page that
     is still opening in another tab to take it first), also while the page
     stays open (a second sweep), instead of waiting for the next page load. */
  var HANDOFF_IDLE_MS = 15 * 1000;
  function sweepHandoffs(maxAge) {
    if (!window.indexedDB) return;
    // (v96) without indexedDB.databases() (Firefox before 126) a copy that was
    // never picked up stayed on disk: there each database is opened in a way
    // that never creates it (see sweepOne)
    if (!indexedDB.databases) { HANDOFF_STORES.forEach(function (h) { sweepOne(h, maxAge); }); return; }
    indexedDB.databases().then(function (dbs) {
      var names = dbs.map(function (d) { return d.name; });
      HANDOFF_STORES.forEach(function (h) { if (names.indexOf(h.db) >= 0) sweepOne(h, maxAge); });
    }).catch(function () { /* storage unavailable (private mode): nothing stored */ });
  }
  function sweepOne(h, maxAge) {
    var rq;
    try { rq = indexedDB.open(h.db); } catch (e) { return; /* storage blocked: nothing can have been stored either */ }
    // a database that does not exist yet would be created here: cancel that
    rq.onupgradeneeded = function () { rq.transaction.abort(); };
    rq.onsuccess = function () {
      var db = rq.result;
      if (!db.objectStoreNames.contains(h.store)) { db.close(); return; }
      // (v137) app.js stores each copy under its own key: check them all
      var tx = db.transaction(h.store, 'readwrite'), c = tx.objectStore(h.store).openCursor();
      var limit = Math.min(h.maxAge, maxAge || h.maxAge);
      c.onsuccess = function () {
        var cur = c.result;
        if (!cur) return;
        var v = cur.value;
        var age = v ? Date.now() - v[h.ts] : NaN;
        if (!(age >= 0 && age < limit)) cur.delete(); // (v137) a negative age (clock set back) counts as expired
        cur.continue();
      };
      tx.oncomplete = tx.onabort = tx.onerror = function () { db.close(); };
    };
    rq.onerror = function (e) { if (e && e.preventDefault) e.preventDefault(); /* no such database (creation cancelled) or storage blocked: nothing to delete */ };
  }


  /* ---------- (v79) feedback during the launch period ----------
     A line under every download ("something not right once you open the
     file?") and a small "Feedback" tab on every page, for problems found
     later. Both open the contact page with the subject already set to
     "problem with a conversion"; the visitor sends the mail from their own
     mail app. Only the tool's name goes into the link, never a file name.
     Both disappear by themselves after FEEDBACK_UNTIL. */
  var FEEDBACK_UNTIL = Date.UTC(2027, 3, 1); // 1 April 2027
  var FEEDBACK_TOOL_MAX = 60;
  function feedbackOn() { return Date.now() < FEEDBACK_UNTIL; }
  function feedbackHref(tool) {
    return S.contact + '?feedback=1' + (tool ? '&tool=' + encodeURIComponent(tool.slice(0, FEEDBACK_TOOL_MAX)) : '');
  }
  function feedbackLink(cls, text, tool) {
    var a = document.createElement('a');
    a.className = cls; a.href = feedbackHref(tool); a.rel = 'nofollow'; a.textContent = text;
    return a;
  }
  function toolName(panel) {
    var tab = document.getElementById(panel.id.replace(/^panel-/, 'tab-'));
    var h = tab || document.querySelector('h1');
    return h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function setupFeedback() {
    if (!feedbackOn()) return;
    var addLine = function (box) {
      var line = document.createElement('p');
      line.className = 'pc-fb';
      line.appendChild(feedbackLink('', S.fbLink, toolName(box.closest('.panel'))));
      box.appendChild(line);
    };
    document.querySelectorAll('.panel .result-box').forEach(addLine);
    // (v116) a panel made from its template when its tab is opened (app.js pcMaterializePanel)
    document.addEventListener('pc-panel', function (e) { e.detail.querySelectorAll('.result-box').forEach(addLine); });
    if (document.getElementById('ct-form')) return; // already on the contact page
    // its own landmark, so screen readers can find it (and axe 'region' passes)
    var aside = document.createElement('aside');
    aside.className = 'pc-fb-aside'; // (v111) hidden on phones by class (style.css)
    aside.setAttribute('aria-label', S.fbTab);
    aside.appendChild(feedbackLink('pc-fb-tab', S.fbTab, ''));
    document.body.appendChild(aside);
  }

  /* (v136) the theme button, in the footer next to the language menu (the
     two go together in .footer-prefs). One click = the next theme; the button
     shows the active one. A short message also says it, for screen readers
     and because "automatic" can look exactly like the theme before it. */
  var THEME_ICONS = {
    auto: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.8"/><path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor"/></svg>',
    light: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.8"/><path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    dark: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>'
  };
  var THEME_NAMES = { auto: 'themeAuto', light: 'themeLight', dark: 'themeDark' };
  function themeLabel(t) { return S.theme.replace('{m}', S[THEME_NAMES[t]]); }
  // the visible text is part of the spoken name (WCAG 2.5.3 label in name)
  function themeShort(t) { var n = t === 'auto' ? S.themeAutoShort : S[THEME_NAMES[t]]; return n.charAt(0).toUpperCase() + n.slice(1); }
  function currentTheme() { return document.documentElement.getAttribute('data-theme') || 'auto'; }
  function saveTheme(t) {
    try {
      if (t === 'auto') localStorage.removeItem(THEME_KEY); else localStorage.setItem(THEME_KEY, t);
      return true;
    } catch (e) { return false; } // the caller tells the visitor the choice only holds for this page
  }
  function setupTheme() {
    var b = null;
    var show = function (t) {
      if (!b) return;
      b.innerHTML = THEME_ICONS[t] + '<span></span>';
      b.lastChild.textContent = themeShort(t);
      b.setAttribute('aria-label', themeLabel(t));
    };
    // another tab changed it, or the page came back from the back/forward
    // cache. Blocked storage: keep what this page shows (a choice made here
    // could not be saved, and must not silently flip back to automatic).
    var sync = function () { var t = storedTheme(); if (t === null) return; applyTheme(t); show(t); };
    window.addEventListener('storage', function (e) { if (e.key === THEME_KEY || e.key === null) sync(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
    var lang = document.querySelector('footer .footer-bottom > details.lang-menu');
    if (!lang) return;
    b = document.createElement('button');
    b.type = 'button'; b.className = 'pc-theme';
    show(currentTheme());
    b.addEventListener('click', function () {
      var next = THEMES[(THEMES.indexOf(currentTheme()) + 1) % THEMES.length];
      applyTheme(next); show(next);
      if (saveTheme(next)) toast(themeLabel(next), false, THEME_TOAST_MS); else toast(S.themeNoSave);
    });
    var box = document.createElement('div');
    box.className = 'footer-prefs';
    lang.parentNode.insertBefore(box, lang);
    box.appendChild(b);
    box.appendChild(lang);
  }

  function init() {
    var toolPage = !!document.querySelector('script[src^="/app.js"]');
    sweepHandoffs(toolPage ? 0 : HANDOFF_IDLE_MS);
    if (!toolPage) setTimeout(function () { sweepHandoffs(HANDOFF_IDLE_MS); }, HANDOFF_IDLE_MS + 1000);
    toastNode();
    setupTheme();
    document.querySelectorAll('.panel').forEach(setupPanel);
    document.addEventListener('pc-panel', function (e) { setupPanel(e.detail); }); // (v116)
    setupOffline();
    setupFeedback();
    // (v139) the first Intl.NumberFormat of a page sets up the locale data (~80 ms on a slow phone): do it while
    // the page is idle, not inside the click on a tool's start button. Only tool pages need it.
    if (toolPage) whenIdle(function () { numFormat(0); numFormat(1); numFormat(2); numFormat(null); });
  }
  function whenIdle(cb) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(cb, { timeout: IDLE_WARM_TIMEOUT_MS });
    else window.setTimeout(cb, IDLE_WARM_TIMEOUT_MS);
  }
  // (v147) deferred: the page is parsed ('interactive'), but init keeps running at DOMContentLoaded, after
  // the other deferred scripts (app.js makes its panels first), exactly as when this file blocked the page
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* (v122) The demo recording on the merge page sits folded in a <details>:
   nothing (not even the poster) is downloaded until it is opened. Opening it
   is the visitor's own click, so it then plays (muted, with controls); if the
   browser still refuses, the controls stay for the visitor to press play. */
(function demoVideo(){
  function start(){
    document.querySelectorAll('details.demo-more').forEach(function(d){
      var v = d.querySelector('video.pc-demo[data-src]');
      if(!v) return;
      d.addEventListener('toggle', function(){
        if(!d.open){ v.pause(); return; }
        if(!v.getAttribute('src')){ v.poster = v.getAttribute('data-poster'); v.src = v.getAttribute('data-src'); }
        var p = v.play();
        if(p && p.catch) p.catch(function(){ v.controls = true; }); // refused (no codec, power saving): the visible controls let the visitor start it
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* (v65) The footer's language menu (<details class="lang-menu">) closes with
   Escape (focus back on its button) and when clicking elsewhere. */
(function langMenu(){
  function start(){
    var menus = document.querySelectorAll('details.lang-menu');
    if(!menus.length) return;
    document.addEventListener('keydown', function(e){
      if(e.key !== 'Escape') return;
      menus.forEach(function(d){
        if(!d.open) return;
        d.open = false;
        if(d.contains(document.activeElement)) d.querySelector('summary').focus();
      });
    });
    document.addEventListener('click', function(e){
      menus.forEach(function(d){ if(d.open && !d.contains(e.target)) d.open = false; });
    });
    // (v119) on a phone the button wraps to the left edge, and a list anchored
    // on its right side fell off the screen ("glish", "derlands"): it then opens
    // to the right instead
    menus.forEach(function(d){
      d.addEventListener('toggle', function(){
        if(!d.open) return;
        var nav = d.querySelector('nav, .lang-list'); // (v121) the header copy uses a div
        if(!nav) return;
        d.classList.remove('lang-menu--left');
        if(nav.getBoundingClientRect().left < LANG_MENU_EDGE_PX) d.classList.add('lang-menu--left');
      });
    });
  }
  var LANG_MENU_EDGE_PX = 8;
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
